'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = options;
var OPTIONS_DEFAULTS = {
    themeVariations: ['primary', 'secondary', 'accent'],
    minifyTheme: null,
    themeCache: null,
    cspNonce: null
};
function options() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.assign({}, OPTIONS_DEFAULTS, options);
}
//# sourceMappingURL=options.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/Vuetify/mixins/options.js
// module id = Gnu1
// module chunks = 3 4 5 6 7 8 9